import { _ as __rest } from './tslib.es6-DN65qNZS.js';
import React, { useState, useId, useEffect } from 'react';
import classnames from 'classnames';
import { useFormContext, useForm, Controller } from 'react-hook-form';
import { I as Icon } from './Icon-8KKXFsxm.js';
import { T as Text } from './Text-BCmEgJBp.js';

var styles = {"checkBoxParent":"S4ILp9Wc1GY-","wrapper":"OFHQaLxY8zI-","disabled":"HRrf3AZlpHc-","checkHolder":"kMH5B1jwh-Y-","input":"rup0RBe4DNU-","checkBox":"lOQVnJA7zPM-","indeterminate":"Njn2CQDXwVA-","label":"eHENKCs5umc-","description":"fSEH0cAO9cI-"};

function Checkbox({ checked, defaultChecked, disabled, label, name, value, indeterminate = false, description, children, onChange, onFocus, }) {
    const { control, setValue, watch } = useFormContext() != undefined
        ? useFormContext()
        : // If there isn't a Form Context being provided, get a form for this field.
            useForm({ mode: "onTouched" });
    const [identifier] = useState(useId());
    /**
     * Generate a name if one is not supplied, this is the name
     * that will be used for react-hook-form and not neccessarily
     * attached to the DOM
     */
    const [controlledName] = useState(name ? name : `generatedName--${identifier}`);
    useEffect(() => {
        if (value != undefined) {
            setValue(controlledName, value);
        }
    }, [value, watch(controlledName)]);
    const wrapperClassName = classnames(styles.wrapper, disabled && styles.disabled);
    const inputClassName = classnames(styles.input, {
        [styles.indeterminate]: indeterminate,
    });
    const iconName = indeterminate ? "minus2" : "checkmark";
    const labelText = label ? React.createElement(Text, null, label) : children;
    return (React.createElement(Controller, { control: control, name: controlledName, defaultValue: defaultChecked, render: (_a) => {
            var _b = _a.field, { onChange: onControllerChange, name: controllerName } = _b, rest = __rest(_b, ["onChange", "name"]);
            const fieldProps = Object.assign(Object.assign({}, rest), { id: identifier, className: inputClassName, name: name && controllerName, onChange: handleChange, disabled: disabled });
            return (React.createElement("div", { className: styles.checkBoxParent },
                React.createElement("label", { className: wrapperClassName },
                    React.createElement("span", { className: styles.checkHolder },
                        React.createElement("input", Object.assign({}, fieldProps, { type: "checkbox", checked: checked, defaultChecked: defaultChecked, "aria-label": label, onChange: handleChange, onFocus: onFocus })),
                        React.createElement("span", { className: styles.checkBox },
                            React.createElement(Icon, { name: iconName, color: "surface" }))),
                    labelText && React.createElement("span", { className: styles.label }, labelText)),
                description && (React.createElement("div", { className: styles.description },
                    React.createElement(Text, { variation: "subdued", size: "small" }, description)))));
            function handleChange(event) {
                const newChecked = event.currentTarget.checked;
                onChange && onChange(newChecked);
                onControllerChange(event);
            }
        } }));
}

export { Checkbox as C };
